export const assetUseCaseEnum = {
  NONE: 'NONE',
  PROCESS: 'PROCESS',
  COMMERCIAL: 'COMMERCIAL',
  DOMESTIC: 'DOMESTIC',
} as const

export type AssetUseCaseEnum = (typeof assetUseCaseEnum)[keyof typeof assetUseCaseEnum]

export type AssetUseCase = AssetUseCaseEnum